import { TableHeaderCell } from 'common/components';

export type StatusFilterOption = { value: string; label: string };

type StatusFilterCellProps = {
    filterStatus: string;
    statusOptions: StatusFilterOption[];
    onFilterStatus: (value: string) => void;
};

export const StatusFilterCell = ({ filterStatus, statusOptions, onFilterStatus }: StatusFilterCellProps) => {
    const options = [{ value: '', label: 'All statuses' }, ...statusOptions];
    const selectedValues = filterStatus ? filterStatus.split(',').filter(Boolean) : [];

    return (
        <TableHeaderCell
            label='Status'
            isSearchable
            filterOptions={{
                mode: 'multi',
                options,
                selectedValues,
                onChange: (values) => onFilterStatus(values.join(',')),
            }}
        />
    );
};
